import "./style.css";
import { useEffect, useState } from "react";
function IntegrationsContent() {
  const searchParams = new URLSearchParams(document.location.search);
  const sessionkey = searchParams.get("sessionkey");
  useEffect(() => {
  }, []);

  const handleConnect = async () => {
    if (!sessionkey)
      return alert("please Refresh Your Page")
    const temp_url = `https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=redirect_uri&client_id=client_id&scope=scope&state=${"agency._id"}&sessionKey=${sessionkey}`
    var windowFeatures = 'width=600,height=600,menubar=no,location=no,toolbar=no,scrollbars=yes'

    // Open the URL in a new window with the specified features
    window.open(temp_url, '_blank', windowFeatures)
  };

  return (
    <div className="settingsPage">
      <div className="form-border p-5 mb-6">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <h2 className="py-2" style={{ fontSize: "20px", fontWeight: "bold" }}>Connect with Go High Level</h2>
          </div>
          <div className="flex justify-end">
            <button className="px-10 py-2 me-12 text-xs bg-green-800 text-white rounded-md uppercase font-bold" onClick={handleConnect} >
              Connect
            </button>
          </div>
        </div>
      </div>

    </div>
  );
}
export default IntegrationsContent;



